
import { defineComponent } from "vue";
import formatters from "@/utils/formatters";
import validators from "@/utils/validators";

type ComponentData = {
  text?: string;
  validation_message?: string;
};

export default defineComponent({
  name: "TextField",
  data(): ComponentData {
    const text = this.modelValue;
    return { text, validation_message: undefined };
  },
  methods: {
    formatInput(e: Event) {
      const formatter = formatters[this.$props.format as string];
      if (formatter) formatter(e);
      this.text = (e.target as HTMLInputElement).value;
    },
    validate() {
      this.validation_message = undefined;

      for (let name in this.$props.validators) {
        const message = validators[name](
          this.text,
          this.$props.validators[name]
        );
        if (message) {
          this.$emit("updateValidation", this.$props.name, false);
          return (this.validation_message = message as string);
        }
      }
      this.$emit("updateValidation", this.name, true);
    },
  },
  props: {
    modelValue: String,
    name: String,
    label: String,
    readonly: Boolean,
    maxlength: Number,
    not_editable: Boolean,
    manual_focus: Boolean,
    format: String,
    validators: Object,
    validation: Object,
  },
  emits: ["update:modelValue", "updateValidation"],
  watch: {
    text(n) {
      this.$emit("update:modelValue", n);
    },
    modelValue(n) {
      this.text = n;
    },
    validation(value) {
      this.validation_message = value.message;
    },
  },
});
